import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getDivision({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.advanceFilter
        .getDivision(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getHouse({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.advanceFilter
        .getHouse(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getDept({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.advanceFilter
        .getDept(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getBO({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.advanceFilter
        .getBO(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getDiv({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.advanceFilter
        .getDiv(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getDetail({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.advanceFilter
        .getDetail(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    }
  },
  getters: {}
};
